export default __webpack_public_path__ + "static/vosmigrannoj-piramidy-s-mednoj-zhestyu-v-blizi-81bb8d9d8b61caf6f14957aa52aa0da8.jpg";